"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Directory/PatientPage/AccessHistory.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; } function _nullishCoalesce(lhs, rhsFn) { if (lhs != null) { return lhs; } else { return rhsFn(); } }var _react = require('react'); var _react2 = _interopRequireDefault(_react);
var _moment = require('moment'); var _moment2 = _interopRequireDefault(_moment);





var _auditFormat = require('shared/utils/auditFormat');

var _actions = require('web/actions'); var _actions2 = _interopRequireDefault(_actions);
var _routes = require('web/chat/routes'); var _routes2 = _interopRequireDefault(_routes);
var _Avatar = require('web/components/Avatar');
var _useAuditExport = require('web/components/Audit/useAuditExport');
var _store = require('web/store');







const EVENT_LIMIT = 4

/* Access history (screen C): the last four views or exports of this
 * patient's chats, for the Owners and IT of an account that records the
 * audit log; nothing for anyone else (the server says which, as Visible).
 * See all opens Account → Audit filtered to the patient; Download CSV is the
 * patient's last 12 months. */
const AccessHistory = ({ orgKey, patientKey, patientName }) => {
  // The events, or null while loading and when the card isn't shown.
  const [events, setEvents] = _react.useState(null)
  const { state: csvState, isPreparing, start: startCsv, dismiss } = _useAuditExport.useAuditExport.call(void 0, )

  _react.useEffect.call(void 0, () => {
    let isCurrent = true
    setEvents(null)
    _actions2.default.getPatientAccessHistory({ OrgKey: orgKey, PatientKey: patientKey, Limit: EVENT_LIMIT })
      .then(({ Visible, Events }) => {
        if (isCurrent) setEvents(Visible ? (_nullishCoalesce(Events, () => ( []))).slice(0, EVENT_LIMIT) : null)
      })
      // Most people who ask can't see the card, so a failed read shows nothing.
      .catch(() => undefined)
    return () => { isCurrent = false }
  }, [orgKey, patientKey])

  const seeAll = _react.useCallback.call(void 0, () => {
    const path = _routes.makeRoute.call(void 0, _routes2.default.SETTINGS.ACCOUNT_PAGE, { orgKey, tabName: 'audit' })
    _store.history.push(`${path}?${_routes.AUDIT_PATIENT_PARAM}=${encodeURIComponent(patientKey)}`)
  }, [orgKey, patientKey])

  const download = _react.useCallback.call(void 0, () => {
    const to = _moment2.default.call(void 0, ).startOf('day').add(1, 'day')
    startCsv({
      OrgKey: orgKey,
      From: to.clone().subtract(12, 'months').toISOString(),
      To: to.toISOString(),
      PatientKey: patientKey,
    })
  }, [startCsv, orgKey, patientKey])

  if (!events) return null

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "directory-page--section-title audit-card--title" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 65}}, "Access history"

        , _react2.default.createElement('span', { className: "audit-card--lock", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}}, _react2.default.createElement('img', { alt: "", src: "/assets/icons/padlock.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 67}} ), "Owners and IT only"   )
      )
      , _react2.default.createElement('div', { className: "directory-page--section audit-card" , __self: this, __source: {fileName: _jsxFileName, lineNumber: 69}}
        ,  events.length === 0 && (
          _react2.default.createElement('div', { className: "audit-card--empty", __self: this, __source: {fileName: _jsxFileName, lineNumber: 71}}
            , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 72}}, "No one has opened "    ,  _auditFormat.firstName.call(void 0, patientName) || 'this patient' , "'s chats yet"  )
            , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 73}}, "Views and exports of this patient's chats show here."        )
          )
        )
        ,  events.length > 0 && (
          _react2.default.createElement('ul', { className: "audit-card--list", __self: this, __source: {fileName: _jsxFileName, lineNumber: 77}}
            ,  events.map(e => (
              _react2.default.createElement('li', { key: e.AuditKey, className: "audit-card--item", __self: this, __source: {fileName: _jsxFileName, lineNumber: 79}}
                /* SAFETY: the avatar only looks the key up; Support has none and gets the default. */
                , _react2.default.createElement(_Avatar.UserAvatar, { userKey: (e.Person.UserKey || e.AuditKey) , size: 28, noOnlineIndicator: true, __self: this, __source: {fileName: _jsxFileName, lineNumber: 81}} )
                , _react2.default.createElement('span', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 82}}
                  , _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 83}},  e.Person.Name ), " " ,  _auditFormat.accessVerb.call(void 0, e) 
                  , _react2.default.createElement('span', { className: "audit-card--when", __self: this, __source: {fileName: _jsxFileName, lineNumber: 84}},  [_auditFormat.formatEventTime.call(void 0, e.OccurredAt), e.ChatName].filter(Boolean).join(' · ') )
                )
              )
            ))
          )
        )
        , _react2.default.createElement('div', { className: "audit-card--links", __self: this, __source: {fileName: _jsxFileName, lineNumber: 90}}
          , _react2.default.createElement('button', { type: "button", className: "dir-link", onClick: seeAll, __self: this, __source: {fileName: _jsxFileName, lineNumber: 91}}, "See all in Audit log →"     )
          , _react2.default.createElement('button', { type: "button", className: "dir-link audit-card--csv" , disabled: isPreparing, onClick: download, __self: this, __source: {fileName: _jsxFileName, lineNumber: 92}}
            , _react2.default.createElement('img', { alt: "", src: "/assets/icons/icon-download-purple.svg", __self: this, __source: {fileName: _jsxFileName, lineNumber: 93}} )
            ,  isPreparing ? 'Preparing CSV…' : 'Download CSV' 
          )
        )
      )
      , _react2.default.createElement(_useAuditExport.AuditExportToast, { state: csvState, dismiss: dismiss, __self: this, __source: {fileName: _jsxFileName, lineNumber: 98}} )
    )
  )
}

exports. default = AccessHistory
